/****************************************************
 * Module Name:  userPermissionProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class UserPermissionProxy {
  static GetAllUserPermission = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/users",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUserPermission = (userids, userToken, callback) => {
    if (userToken === undefined || userToken === null || userToken === "")
      userToken = Constants.userToken;

    restAPICall(
      Constants.MANAGER_URL + "/permission/users/getpermission/detail",
      "post",
      userToken,
      undefined,
      JSON.stringify(userids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };


  static GetSingleUserStoneTypePermission = (userids, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/users/getpermission/detail/stonetype",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(userids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUserByPermission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/userpermission/permission",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUserWithoutPermission = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/userpermission/withoutpermission",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddUserPermission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/users",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteUserPermission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/users",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddVirtualTeamPermission = (vtid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/permission/vt/${vtid}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteVirtualTeamPermission = (vtid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/permission/vt/${vtid}`,
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
